/**
 * Lawyer Booking Detail page
 * Uses shared BookingDetail component
 */
import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from '../index'
import { BookingDetail } from '@/components/bookings'

function BookingDetailPage() {
  const { accessId } = lawyerBookingDetailRoute.useParams()

  return (
    <BookingDetail
      accessId={accessId}
      backRoute="/lawyer/bookings"
    />
  )
}

export const lawyerBookingDetailRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/bookings/$accessId',
  component: BookingDetailPage,
})
